function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mobile---Header-3",
  transform: "translate(-303.000000, -16.000000)",
  fill: "#C6C6C6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mobile---Header-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "PeopleList",
  transform: "translate(303.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,2 L13,2 C14.6568542,2 16,3.34314575 16,5 L16,13 C16,14.6568542 14.6568542,16 13,16 L3,16 C1.34314575,16 2.02906125e-16,14.6568542 0,13 L0,5 C-2.02906125e-16,3.34314575 1.34314575,2 3,2 Z M12,11.0310066 C12,10.0024642 10.9226459,9.15227024 9.52560311,9.01856415 C9.39922179,9.00618805 9.27035019,9 9.13929961,9 L6.86070039,9 C6.72964981,9 6.60077821,9.00618805 6.47439689,9.01856415 C5.07735409,9.15227024 4,10.0024642 4,11.0310066 L4,12.5817762 C4,13.1263246 4.55190661,13.5919754 5.307393,13.6850172 L7.73042802,13.9835906 C7.90879377,14.0054698 8.09120623,14.0054698 8.26957198,13.9835906 L10.692607,13.6850172 C11.4480934,13.5919754 12,13.1263246 12,12.5817762 L12,11.0310066 Z M10,6 C10,5.70041056 9.93407625,5.41630499 9.81607038,5.16129032 C9.49888563,4.47554252 8.80492669,4 8,4 C7.17747801,4 6.47085044,4.49665689 6.16375367,5.20633431 C6.05841642,5.44961877 6,5.71800587 6,6 C6,6.4229912 6.1313783,6.81524927 6.35542522,7.13829912 C6.71648094,7.65912023 7.31847507,8 8,8 C8.66041056,8 9.24621701,7.6797654 9.61008798,7.18615836 C9.85524927,6.85419355 10,6.44410557 10,6 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  x: 3,
  y: 17,
  width: 10,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  x: 3,
  y: 0,
  width: 10,
  height: 1
})))));

var SvgPeopleList = function SvgPeopleList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeopleList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PeopleList.be088b12.svg";
export { ForwardRef as ReactComponent };